import { render } from "./report-mes.vue?vue&type=template&id=58b15ade&scoped=true"
import script from "./report-mes.vue?vue&type=script&lang=js"
export * from "./report-mes.vue?vue&type=script&lang=js"

import "./report-mes.vue?vue&type=style&index=0&id=58b15ade&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b15ade"]])

export default __exports__